import React from 'react'

import DateFilter from '../../../../components/filter/DateFilter'
import EntitiesFilter from './EntitiesFilter'
import LevelsFilter from './LevelsFilter'
import OriginsFilter from './OriginsFilter'
import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'
import UsersFilter from '../../../../containers/users/filters/UsersFilter'

const FiltersBar = ({ open }) => {
  return (
    <ScreenViewFilterBar screen="logs" open={open}>
      <UsersFilter />
      <LevelsFilter />
      <OriginsFilter />
      <DateFilter label="Data do log" field="insertedAt" />
      <EntitiesFilter />
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
